module.exports = __webpack_public_path__ + "img/36.3.TP.de0dd6a6.png";